import React, { useState } from 'react'
import { useAppSelector } from '../../../../../../../../store/hooks'
import { selectRoomSession } from '../../../../../../../../store/meetingSummary/roomSession'
import { selectSessionMeetingTemplate } from '../../../../../../../../store/meetingSummary/meetingTemplates'
import { useGetAgendaQuery } from '../../../../../../../../store/agenda/agenda'
import { AgendaModal } from './AgendaModal'
import { selectAccountId } from '../../../../../../../../store/auth/authSlice'
import { AgendaItemStatus } from '../../../../../../../../models/Agenda'
import { useTracking, TrackEvent } from '../../../../../common/tracking'
import { getRoomTrackingDetails } from '../../../../../tracking'

export const AgendaBox: React.FC = () => {
  const [showModal, setShowModal] = useState(false)
  const roomSession = useAppSelector(selectRoomSession)
  const sessionMeetingTemplate = useAppSelector(selectSessionMeetingTemplate)
  const accountId = useAppSelector(selectAccountId)
  const { tracked } = useTracking()

  const { roomId, id: sessionId } = roomSession ?? {}
  const meetingTemplateId = sessionMeetingTemplate?.id

  const { data: agenda } = useGetAgendaQuery(
    {
      accountId,
      roomId: roomId!,
      sessionId: sessionId!,
      meetingTemplateId: meetingTemplateId!,
    },
    {
      skip: !accountId || !roomId || !sessionId || !meetingTemplateId,
    },
  )

  if (!agenda || agenda.items.length === 0) {
    return null
  }

  const completedItems = agenda.items.filter((item) => item.status === AgendaItemStatus.Completed).length
  const openItems = agenda.items.length - completedItems

  const allCovered = openItems === 0

  const messageText = allCovered
    ? 'All agenda items were covered.'
    : `${openItems} uncovered agenda item${openItems > 1 ? 's' : ''} added as ${openItems > 1 ? 'tasks' : 'a task'}.`

  const showAgendaReviewModal = tracked(() => setShowModal(true), {
    eventName: TrackEvent.AGENDA_SHOW_REVIEW_MODAL_CLICKED,
    eventDetails: {
      meetingTemplateId: meetingTemplateId ?? '',
      ...getRoomTrackingDetails(roomSession),
    },
  })

  return (
    <>
      <div className='zocks-bg-color-gray-200 rounded d-flex align-items-center gap-4 px-4 py-2'>
        <p className='mb-0 flex-grow-1 fw-medium text-gray-900 paragraph-medium'>
          {messageText}{' '}
          <button onClick={showAgendaReviewModal} className='btn btn-link p-0 text-decoration-underline fw-bold text-gray-900 paragraph-medium align-baseline'>
            Review Agenda
          </button>
        </p>
      </div>

      {showModal ? <AgendaModal show={showModal} onHide={() => setShowModal(false)} agenda={agenda} /> : null}
    </>
  )
}
